module.exports = __webpack_public_path__ + "../resources/images/illustration_drink-6c0e66efeaede4d574fd58b8f1a5e883.svg";